import { render, staticRenderFns } from "./GeneralRules_EN.vue?vue&type=template&id=39a0b0d8&scoped=true&"
import script from "./GeneralRules_EN.vue?vue&type=script&lang=js&"
export * from "./GeneralRules_EN.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRules_EN.vue?vue&type=style&index=0&id=39a0b0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0b0d8",
  null
  
)

export default component.exports